import React from 'react';
import { FaFacebook } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { Link } from 'react-router-dom';
import "../sass/layout/_footer.scss";
import "../sass/base/_footer_typo.scss";

export default function Footer() {
  return (
    <footer className='footer-page'>
      <div className="logo">
        <h2>EH.</h2>
        <span className="logo_para">
            Evanescence Hypnose
        </span>
      </div>
      <nav className="footer-content">
        <ul>
          <li className='heading-footer'>Contact</li>
          <Link
            to='https://www.instagram.com/accounts/emailsignup/'
            target='_blank'
            rel='noreferrer'
          >
            <li>Instagram</li>
          </Link>
          <Link
            to='https://www.facebook.com/r.php?locale=fr_FR'
            target='_blank'
            rel='noreferrer'
          >
            <li>Facebook</li>
          </Link>
          <Link
            to='https://workspace.google.com/intl/fr/gmail/'
            target='_blank'
            rel='noreferrer'
          >
            <li>Gmail</li>
          </Link>
        </ul>
        <ol>
          <li className='heading-footer'>Autres</li>
          <Link
            to='/legacy'
            target='_blank'
            rel='noreferrer'
          >
            <li>Mentions legales</li>
          </Link>
          <Link
            to='/chartes'
            target='_blank'
            rel='noreferrer'
          >
            <li>Charte graphiques</li>
          </Link>
        </ol>
        <div className="footer-icon">
          <Link
            to='https://www.facebook.com/share/193vWPF2TC/?mibextid=LQQJ4d'
            target='_blank'
            rel='noreferrer'
            aria-label="Facebbok"
            >
              <FaFacebook />
          </Link>
          <Link
            to='mailto:vanessa.moirod@hotmail.com'
            target='_blank'
            rel='noreferrer'
            aria-label="Gmail"
            >
              <BiLogoGmail />
          </Link>
        </div>
      </nav>
    </footer>
  )
}
